import { render, staticRenderFns } from "./AuthorAccessForm.vue?vue&type=template&id=229b1912&scoped=true"
import script from "./AuthorAccessForm.vue?vue&type=script&lang=js"
export * from "./AuthorAccessForm.vue?vue&type=script&lang=js"
import style0 from "./AuthorAccessForm.vue?vue&type=style&index=0&id=229b1912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b1912",
  null
  
)

export default component.exports